import actions from '@/core/store/ata/gestao-pedido/actions'
import state from '@/core/store/ata/gestao-pedido/state'
import mutations from '@/core/store/ata/gestao-pedido/mutations'
import getters from '@/core/store/ata/gestao-pedido/getters'

export default {
	actions,
	state,
	mutations,
	getters,
}
